var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.showNoResults && _vm.scope === "all"
      ? _c("div", [
          _vm.displayPriority === "products"
            ? _c("div", [
                _vm.products.length > 0
                  ? _c(
                      "div",
                      { staticClass: "row mb-4 p-2 bg-white" },
                      [
                        _c("pc-site-search-products-result", {
                          attrs: { products: _vm.products }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.collections.length > 0
                  ? _c(
                      "div",
                      { staticClass: "row mb-4 p-2 bg-white" },
                      [
                        _c("pc-site-search-collections-result", {
                          attrs: { collections: _vm.collections }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _c("div", [
                _vm.collections.length > 0
                  ? _c(
                      "div",
                      { staticClass: "row mb-4 p-2 bg-white" },
                      [
                        _c("pc-site-search-collections-result", {
                          attrs: { collections: _vm.collections }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.products.length > 0
                  ? _c(
                      "div",
                      { staticClass: "row mb-4 p-2 bg-white" },
                      [
                        _c("pc-site-search-products-result", {
                          attrs: { products: _vm.products }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
          _vm._v(" "),
          _vm.pages.length > 0
            ? _c(
                "div",
                _vm._l(_vm.pages, function(page) {
                  return _c("pc-site-search-pages-result", {
                    key: page.id,
                    attrs: { page: page }
                  })
                }),
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.showNoResults && _vm.scope != "all"
      ? _c("div", [
          _vm.scope === "collections"
            ? _c(
                "div",
                { staticClass: "row mb-4 p-2 bg-white" },
                [
                  _vm.collections.length > 0
                    ? _c("pc-site-search-collections-result", {
                        attrs: { collections: _vm.collections }
                      })
                    : _c("p", [
                        _vm._v(_vm._s(_vm.$resourceString["common.noResults"]))
                      ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.scope === "styles"
            ? _c(
                "div",
                { staticClass: "row mb-4 p-2 bg-white" },
                [
                  _vm.products.length > 0
                    ? _c("pc-site-search-products-result", {
                        attrs: { products: _vm.products }
                      })
                    : _c("p", [
                        _vm._v(_vm._s(_vm.$resourceString["common.noResults"]))
                      ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.scope === "pages"
            ? _c("div", [
                _vm.pages.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.pages, function(page) {
                        return _c("pc-site-search-pages-result", {
                          key: page.id,
                          attrs: { page: page }
                        })
                      }),
                      1
                    )
                  : _c("p", [
                      _vm._v(_vm._s(_vm.$resourceString["common.noResults"]))
                    ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }